
<template>
  <div v-if="selectedCount > 0" class="bg-white rounded-lg border border-gray-200 shadow-sm p-3 mb-4 last:mb-0">
    <h2 class="text-xs font-semibold text-gray-800 mb-2 ">Actions en lot</h2>
    <div class="grid grid-cols-2 md:flex md:flex-row gap-2">
      <ActionButton
        v-if="props.activeTab === 'supprime'"
        label="Réactiver"
        variant="success"
        @click="handleReactivate"
        :disabled="selectedCount === 0"
        :title="selectedCount === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined"
        size="sm"
        customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
      />
      <template v-else>
      <ActionButton
        label="Rendre visible"
        variant="success"
        @click="handleMakeVisible"
        :disabled="selectedCount === 0"
        :title="selectedCount === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined"
        size="sm"
        customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
      />
      
      <ActionButton
        label="Rendre invisible"
        variant="warning"
        @click="handleMakeInvisible"
        :disabled="selectedCount === 0"
        :title="selectedCount === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined"
        size="sm"
        customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
      />
      
      <ProductCouleurLieeDelier
        :selected-count="selectedCount"
        @link-colors-selected="handleLinkColors"
        @delink-colors-selected="handleDelinkColors"
      />
      
      <ActionButton
        v-if="props.activeTab === 'brouillon'"
        label="Mettre en ligne"
        variant="success"
        @click="handlePublish"
        :disabled="selectedCount === 0"
        :title="selectedCount === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined"
        size="sm"
        customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
      />

      <ActionButton
        label="Supprimer"
        variant="danger"
        @click="handleDelete"
        :disabled="selectedCount === 0"
        :title="selectedCount === 0 ? 'Sélectionnez des produits pour activer cette action' : undefined"
        size="sm"
        customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
      />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ActionButton } from '@/components'
import ProductCouleurLieeDelier from './ProductCouleurLieeDelier.vue'
import type { ProduitCatalogue } from '@/types'

interface Props {
  products: ProduitCatalogue[]
  selectedIds: number[]
  activeTab?: 'en_ligne' | 'brouillon' | 'supprime'
}

interface Emits {
  (e: 'update:products', products: ProduitCatalogue[]): void
  (e: 'delete-selected'): void
  (e: 'make-visible-selected'): void
  (e: 'make-invisible-selected'): void
  (e: 'link-colors-selected'): void
  (e: 'delink-colors-selected'): void
  (e: 'publish-selected'): void
  (e: 'reactivate-selected'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

// Nombre sélectionné vient du parent
const selectedCount = computed(() => props.selectedIds.length)

// const handleSelectAll = () => {
//   if (selectedProducts.value.length === props.products.length) {
//     selectedProducts.value = []
//   } else {
//     selectedProducts.value = props.products.map(p => p.id)
//   }
// }

// const handleDelete = () => {
//   if (selectedProducts.value.length === 0) return
//
//   if (confirm(`Êtes-vous sûr de vouloir supprimer ${selectedProducts.value.length} produit(s) ?`)) {
//     // Supprimer les produits sélectionnés
//     const updatedProducts = props.products.filter(p => !selectedProducts.value.includes(p.id))
//     emit('update:products', updatedProducts)
//     selectedProducts.value = []
//   }
// }
//
// const handleMakeVisible = () => {
//   if (selectedProducts.value.length === 0) return
//
//   const updatedProducts = props.products.map(product => {
//     if (selectedProducts.value.includes(product.id)) {
//       return { ...product, visible: true }
//     }
//     return product
//   })
//   emit('update:products', updatedProducts)
// }

// const handleMakeInvisible = () => {
//   if (selectedProducts.value.length === 0) return
//
//   const updatedProducts = props.products.map(product => {
//     if (selectedProducts.value.includes(product.id)) {
//       return { ...product, visible: false }
//     }
//     return product
//   })
//   emit('update:products', updatedProducts)
// }
//
// const handleLinkColors = () => {
//   if (selectedProducts.value.length === 0) return
//   alert(`Liaison des couleurs pour ${selectedProducts.value.length} produit(s)`)
// }

const handleDelete = () => {
  if (!props.selectedIds.length) return
  emit('delete-selected')
}

const handleMakeVisible = () => {
  if (!props.selectedIds.length) return

  emit('make-visible-selected')
}

const handleMakeInvisible = () => {
  if (!props.selectedIds.length) return

  emit('make-invisible-selected')
}

const handleLinkColors = () => {
  if (!props.selectedIds.length) return
  emit('link-colors-selected')
}

const handleDelinkColors = () => {
  if (!props.selectedIds.length) return
  emit('delink-colors-selected')
}

const handlePublish = () => {
  if (!props.selectedIds.length) return
  emit('publish-selected')
}

const handleReactivate = () => {
  if (!props.selectedIds.length) return
  emit('reactivate-selected')
}
</script>
